export class LocationQuery {
  text;
  current;
  pageSize;
}
